module.exports = __webpack_public_path__ + "static/img_9707-fcfd9652d1cd8e59eac7a4d0adac1bb0.webp";